export default __webpack_public_path__ + "static/media/h100-6.f7bd7c50.png";